import styled from "styled-components";

import AgentDescriptionBase from "../AgentDescription";

export const AgentDescription = styled(AgentDescriptionBase)`
  margin-bottom: 28px;
`;
